module.exports = __webpack_public_path__ + "static/media/xiangshanadj.b148e270.webp";